/**
 * Created by jingzhao5 on 2018/02/28.
 */
import 'babel-polyfill'
import { setQueryString } from 'js/libs/utils'
import { checkUserCertificate, checkUidApp } from 'js/api/user'
import { getPackageCerType } from 'js/api/package'
import { showLoginModal } from 'js/libs/utils-login'

import { config } from 'config'
/**
 * 示例
 let params = {
  wareId: '2001',
  packageId: packageId,
  serviceName: '离线语音合成',
  businessId: 'aisound'
}
 */

function goServiceBuy (urlParams, {
  btnStr = '购买',
  callback
} = {}) {
  // -1不需要认证（免费），0默认值需要进行认证，1需要进行个人以上认证（含个人企业），2需要进行企业以上认证
  Promise.all([
    checkUserCertificate({async: false}),
    getPackageCerType({
      packageId: urlParams.packageId || urlParams.selectPackageId
    }, {async: false})
  ]).then(function (values) {
    let url = `${config.CONSOLE}sale/buy?`
    for (let p in urlParams) {
      if (urlParams[p]) {
        url += `${p}=${urlParams[p]}&`
      }
    }
    url = url.substring(0, url.length - 1)

    let certificateResult = values[0]
    let packageResult = values[1]
    if (packageResult.code === undefined) {
      callback ? callback(url) : window.open(url)
      return
    }
    if (certificateResult.code === undefined) {
      return
    }
    if (certificateResult.code === 80000 || certificateResult.code === 80003) {
      showLoginModal()
      return
    }
    let certificateData = certificateResult.data
    let packageData = packageResult.data
    // 不需要实名认证
    if (packageData === -1) {
      callback ? callback(url) : window.open(url)
      return
    }
    // 下面都是需要认证
    // 需要企业认证
    if (packageData === 2) {
      // 认证是个人认证
      if (certificateData.type !== 'BUSINESS_TEAM' && certificateData.type !== 'COMPANY') {
        // 弹出去企业认证框
        jAlert(`您还未完成企业实名认证，认证后可${btnStr}~`, function (flag) {
          if (flag) {
            window.open(`${config.CONSOLE}user/authentication`)
          }
        }, '去认证')
        return
      }
    }
    // 未实名认证完成
    if (!certificateData.flag) {
      jAlert(`您还未完成实名认证，认证后可${btnStr}~`, function (flag) {
        if (flag) {
          window.open(`${config.CONSOLE}user/authentication`)
        }
      }, '去认证')
      return
    }
    // 实名认证满足要求
    callback ? callback(url) : window.open(url)
  }).catch((e) => {
    console.log(e)
  })
}

function justGoServiceBuy (urlParams) {
  let url = `${config.CONSOLE}sale/buy?`
  for (let p in urlParams) {
    if (urlParams[p]) {
      url += `${p}=${urlParams[p]}&`
    }
  }
  url = url.substring(0, url.length - 1)
  window.open(url)
}

export {
  goServiceBuy,
  justGoServiceBuy
}



// WEBPACK FOOTER //
// ./src/js/libs/utils-services-buy.js